import React from "react";
import { DayButton } from "./DayButton";
import { Habit, Day } from "../types";

interface WeekViewProps {
  currentDate: Date;
  habits: Habit[];
  days: Day[];
  selectedDay: string;
  onDayClick: (day: string) => void;
}

export const WeekView: React.FC<WeekViewProps> = ({
  currentDate,
  habits,
  days,
  selectedDay,
  onDayClick,
}) => {
  // Generate 7 days around current date
  const weekDays: string[] = [];
  for (let i = -3; i <= 3; i++) {
    const date = new Date(currentDate);
    date.setDate(currentDate.getDate() + i);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    weekDays.push(`${year}-${month}-${day}`);
  }

  return (
    <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap" }}>
      {weekDays.map((day) => (
        <DayButton
          key={`daily-${day}`}
          day={day}
          habits={habits}
          days={days}
          selectedDay={selectedDay}
          onClick={onDayClick}
        />
      ))}
    </div>
  );
};